import React from 'react';
import { createRoot } from 'react-dom/client';
import { MDXProvider } from '@mdx-js/react';
import App from './App';
import { MDX_COMPONENTS } from './components/ui/MDXComponents';
import './styles/reset.css';
import './styles/tokens.css';
import './styles/typography.css';
import './styles/globals.css';
import './components/layout/layout.css';
import './components/hero/hero.css';
import './components/gallery/gallery.css';
import './components/ui/ui.css';
import './routes/routes.css';

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root element');

createRoot(root).render(
  <React.StrictMode>
    <MDXProvider components={MDX_COMPONENTS}>
      <App />
    </MDXProvider>
  </React.StrictMode>
);
